module.exports = __webpack_public_path__ + "static/media/spicy-piri-piri-fr.d6e31003.jpg";